module.exports = __webpack_public_path__ + "static/media/alert-table.90d9fac5.svg";